import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { AuthProvider } from './core/auth/AuthContext'
import AppRouter from './core/router/AppRouter'
import InstallPrompt from './components/InstallPrompt'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      staleTime: 5 * 60 * 1000,
    }
  }
})

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <AppRouter/>
        <InstallPrompt />
      </AuthProvider>
    </QueryClientProvider>
  )
}